import React from 'react';
import PropTypes from 'prop-types';
import TweenOne from 'rc-tween-one';
import { Menu } from 'antd';
import ScrollAnim from 'rc-scroll-anim';
import Animate from 'rc-animate';

const Link = ScrollAnim.Link;
const Item = Menu.Item;

class Header extends React.Component {
  state = {
    current: '0',
    phoneOpen: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      phoneOpen: false,
    };
  }
  phoneClick = () => {
    this.setState({
      phoneOpen: !this.state.phoneOpen,
    });
  }

  onFocus = (e) => {
    this.dom = e.target;
    this.setState({
      phoneOpen: false,
    });
    switch (e.target.innerText) {
      case '首页':
        this.setState({
          current: '0',
        });
        break;
      case '产品与服务':
        this.setState({
          current: '1',
        });
        break;
      case '客户与伙伴':
        this.setState({
          current: '2',
        });
        break;
        case '关于我们':
          this.setState({
            current: '3',
          });
          break;
        case '联系方式':
          this.setState({
            current: '4',
          });
          break;
    }
  }

  barAnimate() {
    if (!this.dom) {
      return;
    }
    const bar = this.refs.bar;
    bar.style.left = `${this.dom.getBoundingClientRect().left}px`;
  }

  render() {
    const props = { ...this.props };
    const isMode = props.isMode;
    delete props.isMode;
    return (<TweenOne
      component="header"
      animation={{ opacity: 0, type: 'from' }}
      {...props}
    >
      <TweenOne
        className={`${this.props.className}-logo`}
        animation={{ x: -30, type: 'from', ease: 'easeOutQuad' }}
        id={`${this.props.id}-logo`}
      >
        <img width="100%" src="http://www.hxdream.com/images/logo17064.png" alt="北京华夏梦源科技发展有限公司"/>
      </TweenOne>
      {isMode ? (<div
        className={`${this.props.className}-phone-nav${this.state.phoneOpen ? ' open' : ''}`}
        id={`${this.props.id}-menu`}
      >
        <div
          className={`${this.props.className}-phone-nav-bar`}
          onClick={() => {
            this.phoneClick();
          }}
        >
          <em />
          <em />
          <em />
        </div>
        <div
          className={`${this.props.className}-phone-nav-text`}
        >
          <Menu
            defaultSelectedKeys={['0']}
            selectedKeys={[this.state.current]}
            mode="inline"
            theme="dark"
          >
            <Item key='0'>
              <Link className="nav-list" to="home" onFocus={this.onFocus}>首页</Link>
            </Item>
            <Item key='1'>
              <Link className="nav-list" to="service" onFocus={this.onFocus}>产品与服务</Link>
            </Item>
            <Item key='2'>
              <Link className="nav-list" to="customer" onFocus={this.onFocus}>客户与伙伴</Link>
            </Item>
            <Item key='3'>
              <Link className="nav-list" to="about" onFocus={this.onFocus}>关于我们</Link>
            </Item>
            <Item key='4'>
              <Link className="nav-list" to="contact" onFocus={this.onFocus}>联系方式</Link>
            </Item>
          </Menu>
        </div>
      </div>) : (<TweenOne
        className={`${this.props.className}-nav`}
        animation={{ x: 30, type: 'from', ease: 'easeOutQuad' }}
      >
        <Menu
          mode="horizontal" 
          selectedKeys={[this.state.current]}
          id={`${this.props.id}-menu`}
        >
          <Item key='0'>
            <Link className="nav-list" to="home" onFocus={this.onFocus}>首页</Link>
          </Item>
          <Item key='1'>
            <Link className="nav-list" to="service" onFocus={this.onFocus}>产品与服务</Link>
          </Item>
          <Item key='2'>
            <Link className="nav-list" to="customer" onFocus={this.onFocus}>客户与伙伴</Link>
          </Item>
          <Item key='3'>
            <Link className="nav-list" to="about" onFocus={this.onFocus}>关于我们</Link>
          </Item>
            <Item key='4'>
              <Link className="nav-list" to="contact" onFocus={this.onFocus}>联系方式</Link>
            </Item>
        </Menu>
      </TweenOne>)}
    </TweenOne>);
  }
}

Header.propTypes = {
  className: PropTypes.string,
  dataSource: PropTypes.object,
  id: PropTypes.string,
};

Header.defaultProps = {
  className: 'header0',
};

export default Header;



// WEBPACK FOOTER //
// ./src/Home/Nav.jsx